
import React, { useEffect, useState, useCallback  } from "react"
import { Picker, Button, Space, Input, DatePicker, Switch, setDefaultConfig, Dialog } from 'antd-mobile-v5';
import { Toast } from 'antd-mobile';
import styles from "./remindCalendar.module.scss";
import dayjs from 'dayjs';
import dateUtil from '../../utils/date'
import { ApiCore } from '../../api';
import calendar_icon from '../../static/images_ae/calendar_icon.png';
import remind_calendar_bg from '../../static/images_ae/alkReport/remind_calendar_bg.png';
import icon_time_blue from '../../static/images_ae/alkReport/icon_time_blue.png';
import icon_time_plus_blue from '../../static/images_ae/alkReport/icon_time_plus_blue.svg';
import edit_blue from '../../static/images_ae/alkReport/edit_blue.png';
import icon_cure from '../../static/images_ae/alkReport/icon_cure.png';
import icon_medicine from '../../static/images_ae/alkReport/icon_medicine.png';
import edit_purple from '../../static/images_ae/alkReport/edit_purple.png';
import delete_purple from '../../static/images_ae/alkReport/delete_purple.png';
import survey_edit from '../../static/images_ae/alkReport/survey_edit.png';
import survey_close from '../../static/images_ae/alkReport/survey_close.png';
import time_purple from '../../static/images_ae/alkReport/time_purple.png';
import delete_blue from '../../static/images_ae/alkReport/delete_blue.png';
import cure_blue from '../../static/images_ae/alkReport/cure_blue.png';
import btn_icon_cure_purple from '../../static/images_ae/calendar/btn_icon_cure_purple.png';
import btn_icon_medicine_blue from '../../static/images_ae/calendar/btn_icon_medicine_blue.png';
import btn_icon_medicine_purple from '../../static/images_ae/calendar/btn_icon_medicine_purple.png';
import btn_icon_cure_blue from '../../static/images_ae/calendar/btn_icon_cure_blue.png';
import remind_bell from '../../static/images_ae/calendar/remind_bell.png';
import icon_q from '../../static/images_ae/calendar/icon_q.png';
import btn_icon_medicine_in_blue from '../../static/images_ae/calendar/btn_icon_medicine_in_blue.png';
import icon_delete from '../../static/images_ae/calendar/icon_delete.png';
import utils from "../../utils/utils";
const api = new ApiCore();

const now = new Date();
const maxNow = new Date(now.getTime() + 10 * 365.25 * 24 * 3600 * 1000);
// (每天）(每2天)（每3天）（每4天）（每5天）(每周)(每2周)(每3周)(每月一次)
const _takeMedicineTimes: any = [{
    label: '每天',
    value: 1
}, {
    label: '每2天',
    value: 2
}, {
    label: '每3天',
    value: 3
}, {
    label: '每4天',
    value: 4
}, {
    label: '每5天',
    value: 5
}, {
    label: '每6天',
    value: 6
}, {
    label: '每周',
    value: 7
}, {
    label: '每2周',
    value: 14
}, {
    label: '每3周',
    value: 21
}, {
    label: '每月',
    value: 30
}]
const frequencyToDayMap = {
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 14,
    9: 27,
    10: 30,
}
let deleteLocked = false;
const Calendar = (props: any) => {

    const [currentMonth, setCurrentMonth] = useState(dayjs(new Date()).format('YYYY-MM')) //当前月份 日期格式 2022-03
    const [currentDay, setCurrentDay] = useState(dayjs(new Date()).format('YYYY-MM-DD'))
    const [monthList, setMonthList] = useState<Array<string>>([])
    const [isThisYearMonth, setIsThisYearMonth] = useState(true);
    const [thisDate, setThisDate] = useState<any>(null);

    const [currenrYear, setCurrenrYear] = useState<any>([(new Date().getFullYear()) + '']) // '' needed
    const [yearColumns, setYearColumns] = useState<any>([])
    const [visible, setVisible] = useState(false)

    const [showMask, setShowMask] = useState<Boolean>(false)
    const [isCure, setIsCure] = useState<Boolean>(false)
    const [isMedicine, setIsMedicine] = useState<Boolean>(false)
    const [showMedical, setShowMedical] = useState<any>(false) 
    const [showCure, setShowCure] = useState<any>(false)
    const [activeItem, setActiveItem] = useState<any>({})
    const [takeMedicine, seTakeMedicine] = useState<any>([])
    const [takeMedicineTimes, seTakeMedicineTimes] = useState<any>(_takeMedicineTimes)
    const [takeMedicineTimesMap, seTakeMedicineTimesMap] = useState<any>({})
    
    const [timeVisible, setTimeVisible] = useState(false)

    const [weekList, setWeekList] = useState([
        { name: '周日', className: '' },
        { name: '周一', className: '' },
        { name: '周二', className: '' },
        { name: '周三', className: '' },
        { name: '周四', className: '' },
        { name: '周五', className: '' },
        { name: '周六', className: '' }
    ])

    const [dayList, setDayList] = useState<any>([])
    const [isTodaySigned, setIsTodaySigned] = useState<any>(null)
    const [count, setCount] = useState<any>(null)

    const [selectMedicineTaked, setSelectMedicineTaked] = useState<any>({})

    const [activeDate, setActiveDate] = useState<any>('') // 选中的日期
    const [activeDateCure, setActiveDateCure] = useState<any>(false)  // 选中日期是否有添加过用药提醒
    const [activeDateMedicine, setActiveDateMedicine] = useState<any>(false)  // 选中日期是否有添加过就诊提醒

    // 治疗方式
    const [treatment, setTreatment] = useState<any>('')
    // 选择用药
    const [medicine, setMedicine] = useState<any>('')
    // 选择用药 -> 其他
    const [otherMedicine, setOtherMedicine] = useState<any>('')
    // 使用方式
    const [useWay, setUseWay] = useState<any>('')
    // 开始时间
    const [startTime, setStartTime] = useState<any>('')
    // 服用天数
    const [takedDay, setTakedDay] = useState<any>('')
    // 服用频次code
    const [takedFrequencyTimes, setTakedFrequencyTimes] = useState<any>('')
    // 服用频次展示
    const [takedFrequencyTimesLabel, setTakedFrequencyTimesLabel] = useState<any>('')
    // 提醒时间
    const [remindTimeList, setRemindTimeList] = useState<any>([])

    // 医院名称
    const [hospitalName, setHospitalName] = useState<any>('')
    // 科室名称
    const [departmentName, setDepartmentName] = useState<any>('')
    // 就诊日期
    const [visitTime, setVisitTime] = useState<any>('')
    // 提醒开始日期
    const [visitRemindTime, setVisitRemindTime] = useState<any>('')

    // 设置当前选择的日期类型 'start', 'visit', 'visitRemind'
    const [timeType, setTimeType] = useState<any>('')
    // 设置今天日期
    const [nowDate, setNowDate]= useState<any>('');
    // 设置日历默认时间
    const [pickerDefaultDate, setPickerDefaultDate]= useState<any>('');
    // 设置所有编辑过的列表
    const [editedAllDateList, setEditedAllDateList] = useState<any>([])
    // 设置所有编辑过的就诊列表
    const [editedCureDateList, setEditedCureDateList] = useState<any>([])
    // 设置所有编辑过的用药列表
    const [editedMedicineDateList, setEditedMedicineDateList] = useState<any>([])
    const labelRenderer = useCallback((type: string, data: number) => {
        switch (type) {
          case 'year':
            return data + '年'
          case 'month':
            return data + '月'
          case 'day':
            return data + '日'
        //   case 'hour':
        //     return data + '时'
        //   case 'minute':
        //     return data + '分'
        //   case 'second':
        //     return data + '秒'
        //   default:
        //     return data
        }
      }, [])

    useEffect(() => {

        document.title = '患者日历';

        initMedicineTime();

        initData();

        initConditions();

        initYearColumns();

        initMonth(currentMonth);

        initCalendar(currentMonth);

        return () => {
            deleteLocked = false;
        }

    }, [])

    const initData = () => {
        // 获取频次枚举
        api.getMedicineFrequencyConfig().then((res: any) => {
            if (res.code == 0) {
                const list = res.data.frequencyList || [];
                const takeMedicineTimesMap = {};
                const colums = list.map((val: any) => {
                    takeMedicineTimesMap[val.code] = val.name;
                    return ({
                        label: val.name,
                        value: val.code
                    });
                })
                seTakeMedicineTimes(colums);
                seTakeMedicineTimesMap(takeMedicineTimesMap);
            }
        })
    }

    const initConditions = () => {
        const _takeMedicine = [];
        for (let index = 1; index <= 10; index++) {
            _takeMedicine.push({
                label: `每日${index}次`,
                value: index
            })
            
        }
        seTakeMedicine(_takeMedicine);
        const urlParams = utils.getUrlParams();
        const _isTodaySigned = (urlParams.isTodaySigned == 'true');
        if (urlParams.needHomeInfo == 'true') {
            initHomeInfo();
        } else {
            setIsTodaySigned(_isTodaySigned);
            setCount(urlParams.count);
        }
    }

    const initHomeInfo = () => {
        api.getSignInHome().then((res: any) => {
            if (res.code == 0) {
                const _items = res.data?.items || [];
                const isTodaySigned = _items.some((v: any) => {
                    if (v.todayflag && v.signFlag) {
                        return true;
                    } else {
                        return false;
                    }
                });
                setIsTodaySigned(isTodaySigned);
                setCount(res.data?.count);
            }
        });
    }

    const initYearColumns = () => {
        const _arr = [];
        const _thisYearAndMore = (new Date().getFullYear()) + 10;
        for (let index = _thisYearAndMore; index > 1990; index--) {
            _arr.push({
                label: index + '', value: index + ''
            });
        } 
        setYearColumns([_arr]);
    }

    /**
     * 初始化月份
     * @param monthString  月份 例如：2022-03
     */
    const initMonth = (monthString: any) => {
        let monthList: any = [];

        let year = new Date(monthString).getFullYear()

        let date1 = new Date(monthString);
        let backMonthArr: any = [];

        date1.setMonth(date1.getMonth() - 1, 1) //获取到当前月份,设置月份
        for (let i = 0; i < 4; i++) {
            date1.setMonth(date1.getMonth() + 1); //每次循环一次 月份值加1
            let m: any = date1.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            backMonthArr.push({
                name: year + "-" + m,
                count: 0
            })
        }

        let date = new Date(monthString);
        let forentMonthArr: any = [];

        date.setMonth(date.getMonth() + 1, 1)//获取到当前月份,设置月份
        for (let i = 0; i < 4; i++) {
            date.setMonth(date.getMonth() - 1);//每次循环一次 月份值减1
            let m: any = date.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            forentMonthArr.push({
                name: year + "-" + m,
                count: 0
            })
        }
        forentMonthArr = forentMonthArr.reverse().splice(0, 3)
        monthList = [...forentMonthArr, ...backMonthArr]
        setMonthList(monthList)
    }


    /**
     * 初始化日历
     * @param monthString  月份 例如：2022-03
     */
    const initCalendar = (monthString: any, options = {
        refreshEditedList: true
    }) => {
        let _year = new Date(monthString).getFullYear()
        let _month = new Date(monthString).getMonth() + 1;
        let _date = (new Date()).getDate();
        let _thisYear = new Date().getFullYear();
        let _thisMonth = new Date().getMonth() + 1;
        const _nowDate = `${_thisYear < 10 ? '0' +_thisYear : _thisYear}-${_thisMonth < 10 ? '0' +_thisMonth : _thisMonth}-${_date < 10 ? '0' +_date : _date}`;
        setNowDate(_nowDate);
        setThisDate(_date);
        setIsThisYearMonth((_thisYear == _year) && (_thisMonth == _month));

        //dayCount 一月的总天数  firstDay本月第一天是周几
        let firstDay: any = dateUtil.firstDayOfMonth(monthString);
        let dayCount: any = dateUtil.getDaysInMonth(_year, _month);
        let dayList: any = []

        for (let index = 0; index < dayCount; index++) {
            let dayStr = (index + 1) < 10 ? '0' + (index + 1) : index + 1; //返回的是当天几号  01 02 03
            let dateStr = `${monthString}-${dayStr}`; //返回的是当天日期  2022-02-22

            let count = 0;
            dayList.push({
                name: index + 1, date: dateStr, count: count
            })
        }
        for (let index = 0; index < firstDay; index++) {
            dayList.unshift({ name: '', date: '', count: 0 })
        }
        // 补全缺口
        // while (dayList.length % 7 == 0) {
        //     dayList.push({ name: '', date: '', count: 0 })
        // }
        setDayList(dayList);
        // 获取提醒列表
        api.getHealthRemindList().then((res: any) => {
            if (res.code == 0) {
                let __dayList = dayList;
                if (options.refreshEditedList) {
                    setEditedAllDateList(res.data || []);
                }
                let _cureCount = 0;
                let _medicalCount = 0;
                // 签名高亮
                (res.data || []).forEach((item: any, index: number) => {
                    if (item.type == 'attendance') {
                        _cureCount++;
                    }
                    if (item.type == 'medication') {
                        _medicalCount++;
                    }
                    __dayList = __dayList.map((val: any) => {
                        const isCureEdit =  item.type === 'attendance' && val.date == item.attendanceTime; //  就诊
                        // let isMedicineEdit =  item.type === 'medication' && val.date == item.startTime; // 用药
                        let isMedicineEdit = false // 用药
                        if (item.type === 'medication') {
                            // 提醒的间隔
                            const frequencyGapDay = frequencyToDayMap[item.frequency];
                            // 提醒的天数
                            const dayTimes = item.day ? item.day : 90;
                            // 总天数
                            // const allDay = frequencyGapDay * dayTimes;
                            // 开始时间
                            const startDate = new Date(item.startTime);
                            let futureDays = [item.startTime];
                            for (let index = 1; index < dayTimes; index++) { // 不能用等于，当天算一次
                                let targetDateGap = index * frequencyGapDay;
                                let targetDate = new Date(startDate.getTime() + targetDateGap * 24 * 3600 * 1000);
                                let _year = targetDate.getFullYear();
                                let _month: any =  targetDate.getMonth() + 1;
                                let _date: any =  targetDate.getDate();
                                _month = _month < 10 ? '0' + _month : _month + '';
                                _date = _date < 10 ? '0' + _date : _date + '';
                                futureDays.push(_year + '-' +_month + '-' + _date);
                            }
                            isMedicineEdit = futureDays.some((v: any) => v === val.date);
                        }
                        const isCure = isCureEdit && item.state == 1; // 门诊提醒
                        const isMedicine = isMedicineEdit && item.state == 1; // 用药提醒
                        const isEdit = isCureEdit || isMedicineEdit;
                        if (isEdit) {
                            return {
                                ...val,
                                isEdit: isEdit,
                                isCure: val.isCure || isCure,
                                isMedicine: val.isMedicine || isMedicine,
                            }
                        } else {
                            return val;
                        }
                    })
                })
                // 今天高亮
                __dayList = __dayList.map((val: any) => {
                    let isToday = false;
                    if (((val.name == _date) && (_thisYear == _year) && (_thisMonth == _month))) {
                        isToday = true;
                        if (val.isCure) {
                            setActiveDateCure(true);
                        }
                        if (val.isMedicine) {
                            setActiveDateMedicine(true);
                        }
                        setActiveDate(val.date);
                    }
                    return {
                        isActiveDay: isToday,
                        ...val
                    }
                })
                setShowMedical(_medicalCount == 0);
                setShowCure(_cureCount == 0);
                setDayList(__dayList);
            }
        })
        // const _param = {
        //     year: _year,
        //     month: _month,
        // };
        // api.getSignInCalendar(_param).then((res: any) => {
        //     if (res.code == 0) {
        //         let __dayList = dayList;
        //         // 签名高亮
        //         (res.data?.records || []).forEach((item: any, index: number) => {
        //             __dayList = __dayList.map((val: any) => {
        //                 const isSigned = val.name == item;
        //                 if (isSigned) {
        //                     return {
        //                         ...val,
        //                         isSigned: isSigned
        //                     }
        //                 } else {
        //                     return val;
        //                 }
        //             })
        //         })
        //         // 今天高亮
        //         __dayList = __dayList.map((val: any) => {
        //             let isToday = false;
        //             if (((val.name == _date) && (_thisYear == _year) && (_thisMonth == _month))) {
        //                 isToday = true;
        //             }
        //             return {
        //                 isToday,
        //                 ...val
        //             }
        //         })
        //         setDayList(__dayList);
        //     }
        // });
    }

    //切换年份
    const changeYear = (year: any) => {
        let _year = year.toString()

        let monthNum = new Date(currentMonth).getMonth() + 1 < 10 ? '0' + (new Date(currentMonth).getMonth() + 1) : new Date(currentMonth).getMonth() + 1
        let month = _year + '-' + monthNum

        //切换年份默认选择1号
        let defaultDay = _year + '-' + monthNum + '-01'

        setCurrentMonth(month)
        initMonth(month)
        initCalendar(month)
        setCurrentDay(defaultDay)

    }

    //切换月份
    const changeMonth = (month: string) => {
        setCurrentMonth(month)
        initMonth(month)
        initCalendar(month)
    }

    //切换当天
    const changDay = (day: string) => {
        return;
        setCurrentDay(day)
        let _year = new Date(day).getFullYear() + '';
        let _month: any = new Date(day).getMonth() + 1;
        _month = _month < 10 ? '0' + _month : _month + '';
        let _date: any = (new Date(day)).getDate();
        _date = _date < 10 ? '0' + _date : _date + '';
        let __date = _year + '-' + _month + '-' + _date;
        let __dayList = dayList;
        __dayList = __dayList.map((val: any) => {
            let isActiveDay = false;
            if (val.date == __date) {
                setActiveDate(__date);
                if (val.isCure) {
                    setActiveDateCure(true);
                }
                if (val.isMedicine) {
                    setActiveDateMedicine(true);
                }
                isActiveDay = true;
            }
            return {
                ...val,
                isActiveDay: isActiveDay,
            }
        })
        setDayList(__dayList);
    }

    // 选择用药（其他）
    const medicineNameChanged = (val: string) => {
        setOtherMedicine(val);
    }

    // 服药天数
    const takedDayChanged = (val: string) => {
        setTakedDay(parseInt(val));
    }

    const medicineTaked = async () => {
        const value = await Picker.prompt({
            defaultValue: [takeMedicine[0].value],
            columns: [takeMedicine],
        })
        const index = takeMedicine.findIndex((v: any) => v.value == value?.toString());
        if (index > -1) {
            const item = takeMedicine[index];
            setSelectMedicineTaked(item)
            const count = item.value;
            const list = [];
            let listItem = [];
            for (let index = 1; index <= count; index++) {
                if (index % 4 == 1) {
                    listItem = [];
                }
                listItem.push({
                    index: index
                });
                if (index % 4 == 0 || index == count) {
                    list.push(listItem);
                }
            }
            setRemindTimeList(list);
        }
    }

    const medicineTakedTimes = async () => {
        const value = await Picker.prompt({
            defaultValue: [takeMedicineTimes[0].value],
            columns: [takeMedicineTimes],
        })
        if (value) {
            setTakedFrequencyTimes(value[0]);
            const index = takeMedicineTimes.findIndex((val: any) => val.value == value[0])
            setTakedFrequencyTimesLabel(takeMedicineTimes[index].label);
        }
        // const index = takeMedicine.findIndex((v: any) => v.value == value?.toString());
        // if (index > -1) {
        //     const item = takeMedicine[index];
        //     setSelectMedicineTaked(item)
        //     const count = item.value;
        //     const list = [];
        //     let listItem = [];
        //     for (let index = 1; index <= count; index++) {
        //         if (index % 4 == 1) {
        //             listItem = [];
        //         }
        //         listItem.push({
        //             index: index
        //         });
        //         if (index % 4 == 0 || index == count) {
        //             list.push(listItem);
        //         }
        //     }
        //     setRemindTimeList(list);
        // }
    }

    const initMedicineTime = () => {
        setRemindTimeList([[ {type: 'plus'} ]]);
    }

    const updateMedicineTime = () => {
        // medicineTakedTimes
        // const item = takeMedicine[index];
        // setSelectMedicineTaked(item)
        // const count = item.value;
        // const list = [];
        // let listItem = [];
        // for (let index = 1; index <= count; index++) {
        //     if (index % 4 == 1) {
        //         listItem = [];
        //     }
        //     listItem.push({
        //         index: index
        //     });
        //     if (index % 4 == 0 || index == count) {
        //         list.push(listItem);
        //     }
        // }
        // setRemindTimeList(list);
    }

    // 添加或者编辑提醒时间
    const remindItemActive = async (index: number, innerIndex: number, v: any) => {
        if (v.type == 'plus') {
            const list = [];
            let listItem = [];
            // ↓ 先添加一项
            const minutes:any = [];
            for (let index = 0; index < 24; index++) {
                const value = index < 10 ? ('0' + index) : index + '';
                minutes.push({ label: value, value: value});
            }
            const seconds:any = [];
            for (let index = 0; index < 60; index++) {
                const value = index < 10 ? ('0' + index) : index + '';
                seconds.push({ label: value, value: value});
            }
            const value = await Picker.prompt({
                columns: [minutes, seconds],
            })
            if (!value) {
                return;
            }
            const toAddItem = {
                minute : value[0],
                second : value[1],
                inputed : true
            }
            // ↑
            let count = 0; // 总条数
            remindTimeList.forEach((oVal: any, oIndex: number) => {
                oVal.forEach((iVal: any, iIndex: number) => {
                    count++;
                });
            });
            let addedCount = count + 1; // 添加过后的总条数
            let outerIndex = 0;
            for (let i = 1; i <= addedCount; i++) {
                let modIndex = (i -1) % 4;
                if (i % 4 == 1) {
                    // 换行
                    listItem = [];
                }
                if (i == count) {
                    // 添加新的一类
                    listItem.push({
                        ...toAddItem,
                        index: i,
                    });
                } else if (i == addedCount) {
                    // 添加图标
                    listItem.push({
                        index: i,
                        type: 'plus'
                    });
                } else {
                    const item = remindTimeList[outerIndex][modIndex] || {};
                    // 之前的值保存
                    listItem.push(item);
                }
                if (i % 4 == 0) {
                    // 外数组下标
                    outerIndex++;
                }
                if (i % 4 == 0 || i == addedCount) {
                    list.push(listItem);
                }
            }
            setRemindTimeList(list);
        } else {
            remindItemEdit(index, innerIndex, v);
        }
    }

    // 删除所选时间 
    const remindItemDelete = (index: number, innerIndex: number, v: any) => {
        const list = [];
        let listItem = [];
        let remindTimeArr = remindTimeList.reduce((pre: any, next: any) => (pre.concat(next)), [])
        let addedInArr = 0;
        let count = remindTimeArr.length;
        let toDeleteIndex = index * 4 + innerIndex;
        for (let i = 1; i <= count; i++) {
            if (addedInArr == 4) {
                listItem = [];
                addedInArr = 0;
            }
            // 删除选项不添加
            if ((i - 1) == toDeleteIndex) {
                continue;
            }
            const item = remindTimeArr[i - 1];
            // 之前的值保存
            listItem.push(item);
            addedInArr++;
            if (addedInArr == 4 || i == count) {
                list.push(listItem);
            }
        }
        setRemindTimeList(list);
    }

    // 编辑提醒时间
    const remindItemEdit = async (index: number, i: number, v: any) => {
        const minutes:any = [];
        for (let index = 0; index < 24; index++) {
            const value = index < 10 ? ('0' + index) : index + '';
            minutes.push({ label: value, value: value});
        }
        const seconds:any = [];
        for (let index = 0; index < 60; index++) {
            const value = index < 10 ? ('0' + index) : index + '';
            seconds.push({ label: value, value: value});
        }
        const value = await Picker.prompt({
            defaultValue: [v.minute, v.second],
            columns: [minutes, seconds],
        })
        if (value) {
           const _remindTimeList = JSON.parse(JSON.stringify(remindTimeList));
           _remindTimeList[index][i].minute = value[0];
           _remindTimeList[index][i].second = value[1];
           _remindTimeList[index][i].inputed = true;
            setRemindTimeList(_remindTimeList);
        }
    }

    // 选择治疗方式
    const treatmentEdit = async () => {
        const data = ['化疗', '靶向治疗', '免疫治疗', '其他'];
        const columns:any = [];
        for (let index = 0; index < data.length; index++) {
            columns.push({ label: data[index], value: data[index]});
        }
        const value = await Picker.prompt({
            defaultValue: [treatment],
            columns: [columns],
        })
        if (value) {
            setTreatment(value[0]);
            // 重置选择用药
            setMedicine('');
        }
    }

    // 选择用药
    const selectMedicineEdit =  async () => {
        const dataMap = {
            '化疗': ['足叶乙甙', '顺铂', '卡铂', '伊立替康', '奈达铂', '洛铂', '培美曲塞', '紫杉醇', '多西他赛', '奈达铂', '其他'],
            '靶向治疗': ['洛拉替尼', '厄洛替尼', '埃克替尼', '阿法替尼', '奥西替尼', '克唑替尼', '色瑞替尼', '艾乐替尼', '达拉非尼', '曲美替尼', '其他'],
            '免疫治疗': ['帕博利珠单抗', '纳武单抗', '德瓦鲁单抗', '阿替利珠单抗', '替雷利珠单抗', '信迪利单抗', '特瑞普利单抗', '卡瑞利珠单抗', '其他'],
            '其他': []
        }
        const columns = dataMap[treatment];
        if (!columns) {
            Toast.show('请先选择治疗方式', 1);
            return;
        }
        // 洛拉替尼
        const value = await Picker.prompt({
            defaultValue: [treatment],
            columns: [columns],
        })
        if (value) {
            setMedicine(value[0]);
        }
    }

    const hospitalChange = (val: any) => {
        setHospitalName(val);
    } 
    
    const departChange = (val: any) => {
        setDepartmentName(val);
    }

    const showStartTime = () => {
        setTimeType('start');
        setTimeVisible(true);
    }

    const showUseWay = async () => {
        const value = await Picker.prompt({
            defaultValue: [useWay],
            columns: [['常规用药', '持续用药']],
        })
        if (value) {
            setUseWay(value[0]);
            if (value[0] == '持续用药') {
                setTakedDay('');
            }
        }
    }

    // 就诊日期
    const cureTime = () => {
        setPickerDefaultDate(activeItem.attendanceTime);
        setTimeType('visit');
        setTimeVisible(true);
    }

    // 提醒开始日期
    const cureRemindTime = () => {
        setPickerDefaultDate(activeItem.startTime);
        setTimeType('visitRemind');
        setTimeVisible(true);
    }

    // 用药提醒保存
    const medicineSave = () => {
        const _timeList: any = [];
        remindTimeList.forEach((vv: any) => {
            vv.forEach((v: any) => {
                if (v.type != 'plus') {
                    _timeList.push(`${v.minute}:${v.second}`);
                }
            });
        });
        if (!treatment) {
            Toast.info('请选择治疗方式', 0.7);
            return;
        } else if (!medicine && treatment !== '其他' ) {
            Toast.info('请选择用药', 0.7);
            return;
        } else if ((treatment == '其他' || medicine == '其他') && !otherMedicine) {
            Toast.info('请输入药品名称', 0.7);
            return;
        } else if (!useWay) {
            Toast.info('请选择使用方式', 0.7);
            return;
        } else if (useWay !== '持续用药' && !takedDay) {
            Toast.info('请选择服用天数', 0.7);
            return;
        }else if (!startTime) {
            Toast.info('请选择开始时间', 0.7);
            return;
        } else if (!takedFrequencyTimes) {
            Toast.info('请选择服用频次', 0.7);
            return;
        } else if (_timeList.length == 0) {
            Toast.info('请输入提醒时间', 0.7);
            return;
        } 
        const hasSameTime = _timeList.some((v: any, i: number) => {
            return _timeList.some((vv: any, ii: number) => {
                return (i !== ii && vv === v);
            });
        });
        if (hasSameTime) {
            Toast.info('不能选择相同时间', 1);
            return;
        }
        const param: any = {
            code: activeItem.code || '',
            type: 'medication', // 用药提醒
            treatment: treatment, // 治疗方式
            drugName: medicine, // 选择用药
            medicationType: useWay, // 使用方式
            day: parseInt(takedDay), // 服用天数
            frequency: takedFrequencyTimes, // 服用频次
            startTime: startTime, // 开始时间
            remindTimes: _timeList // .join(';') // '00:00;11:22;'
        };
        if (treatment == '其他' || medicine == '其他') {
            param.otherDrugName = otherMedicine;
        }
        api.setCalendarRemindSave(param).then((res: any) => {
            if (res.code == 0) {
                Toast.info('保存成功', 0.7);
                const _data = res.data || {};
                if (activeItem.code) {
                    // 编辑
                    const _editedAllDateList = editedAllDateList.map((val: any) => {
                        if (_data.code == val.code) {
                            // 更新设置的内容
                            return _data;
                        } else {
                            return val;
                        }
                    });
                    setEditedAllDateList(_editedAllDateList);
                } else {
                    // 新增
                    const _editedAllDateList = editedAllDateList.map((val: any) => val);
                    _editedAllDateList.unshift(_data);
                    setEditedAllDateList(_editedAllDateList);
                }
                setIsMedicine(false);
                initCalendar(currentMonth, {
                    refreshEditedList: false
                });
            }
        });
    }

    // 就诊提醒
    const cureSave = () => {
        const _timeList: any = [];
        remindTimeList.forEach((vv: any) => {
            vv.forEach((v: any) => {
                if (v.type != 'plus') {
                    _timeList.push(`${v.minute}:${v.second}`);
                }
            });
        });
        if (!hospitalName) {
            Toast.info('请输入医院名称', 0.7);
            return;
        } else if (!departmentName) {
            Toast.info('请输入科室名称', 0.7);
            return;
        } else if (!visitTime) {
            Toast.info('请选择就诊日期', 0.7);
            return;
        } else if (!visitRemindTime) {
            Toast.info('请选择就诊提醒开始日期', 0.7);
            return;
        }
        let _visitTime = new Date(visitTime).getTime();
        let _startTime = new Date(visitRemindTime).getTime();
        if (_startTime > _visitTime) {
            Toast.info('提醒开始日期不能大于就诊日期', 1);
            return;
        }
        const param: any = {
            code: activeItem.code || '',
            type: 'attendance', // 就诊提醒
            hospitalName: hospitalName, // 医院
            deptName: departmentName, // 科室
            startTime: visitRemindTime, // 提醒开始日期
            attendanceTime: visitTime // 就诊日期 
        };
        api.setCalendarRemindSave(param).then((res: any) => {
            if (res.code == 0) {
                Toast.info('保存成功', 0.7);
                const _data = res.data || {};
                if (activeItem.code) {
                    // 编辑
                    const _editedAllDateList = editedAllDateList.map((val: any) => {
                        if (_data.code == val.code) {
                            // 更新设置的内容
                            return _data;
                        } else {
                            return val;
                        }
                    });
                    setEditedAllDateList(_editedAllDateList);
                } else {
                    // 新增
                    const _editedAllDateList = editedAllDateList.map((val: any) => val);
                    _editedAllDateList.unshift(_data);
                    setEditedAllDateList(_editedAllDateList);
                }
                setIsCure(false);
                initCalendar(currentMonth, {
                    refreshEditedList: false
                });
            }
        });
    }

    // 刪除设置选项
    const toDelete = async (val: any) => {
        if (deleteLocked) {
            return;
        }
        deleteLocked = true;
        Dialog.confirm({
            content: <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '16px'}}>确定刪除该提醒吗？</div>,
            onConfirm: async () => {
                const res: any = await api.setCalendarRemindDelete({ code: val.code });
                if (res.code == 0) {
                    deleteLocked = false;
                    Toast.info('刪除成功', 0.7);
                    const _editedAllDateList = editedAllDateList.filter((v: any) => v.code != val.code);
                    setEditedAllDateList(_editedAllDateList);
                    initCalendar(currentMonth, {
                        refreshEditedList: false
                    });
                }
            },
            onCancel: () => {
                deleteLocked = false;
            }
          })

    }

    // 切换状态
    const changeSwitch = (v: any, val: any) => {
        let params = {
            code: v.code,
            state: val ? 'ON' : 'OFF'
        }
        api.setHealthState(params).then((res: any) => {
            if (res.code == 0) {
                initCalendar(currentMonth, {
                    refreshEditedList: false
                });
            } else {
                Toast.show(res.message || '设置失败', 1);
            }
        })
    }

    const initMedication = () => {
        setTreatment('');
        setMedicine('');
        setOtherMedicine('');
        setStartTime('');
        setUseWay('');
        setTakedDay('');
        setTakedFrequencyTimes('');
        setTakedFrequencyTimesLabel('');
        initMedicineTime();
    }

    const initCure = ()=> {
        setPickerDefaultDate('');
        setHospitalName('');
        setDepartmentName('');
        setVisitTime('');
        setVisitRemindTime('');
    }

    // 用药编辑
    const toActiveMedication = (val: any) => {
        setTreatment(val.treatment);
        setMedicine(val.drugName);
        setOtherMedicine(val.otherDrugName);
        setStartTime(val.startTime);
        setUseWay(val.medicationType);
        setTakedDay(val.day);
        // 设置频次 ↓
        setTakedFrequencyTimes(val.frequency);
        const index = takeMedicineTimes.findIndex((v: any) => v.value == val.frequency)
        setTakedFrequencyTimesLabel(takeMedicineTimes[index].label);
        // 设置频次 ↑
        // 反显添加时间
        const list = [];
        let listItem = [];
        const _remindTimes = val.remindTimes || [] // .split(';');
        let count = 0; // 总条数
        _remindTimes.forEach((oVal: any, oIndex: number) => {
            count++;
        });
        let addedCount = count + 1; // 添加过后的总条数
        let outerIndex = 0;
        for (let i = 1; i <= addedCount; i++) {
            // let modIndex = (i -1) % 4;
            if (i % 4 == 1) {
                // 换行
                listItem = [];
            }
            // if (i == count) {
            //     // 添加新的一类
            //     listItem.push({
            //         index: i,
            //     });
            // } else 
            if (i == addedCount) {
                // 添加图标
                listItem.push({
                    index: i,
                    type: 'plus'
                });
            } else {
                const item = _remindTimes[i -1] || '';
                const [minute = '', second = ''] = item.split(':');
                // 之前的值保存
                listItem.push({
                    inputed: true,
                    minute: minute.length == 1 ? '0'+ minute : minute + '',
                    second: second.length == 1 ? '0'+ second : second + '',
                });
            }
            if (i % 4 == 0) {
                // 外数组下标
                outerIndex++;
            }
            if (i % 4 == 0 || i == addedCount) {
                list.push(listItem);
            }
        }
        setRemindTimeList(list);

        setIsMedicine(true);
        setActiveItem(val);
    }

    return (
        <div className={styles.ae_calendar}>
                <div className={styles.head}>
                    <div className={styles.head_left}>
                        {/* <div className={styles.title}>可用积分</div> */}
                        {/* <div className={styles.desc}>33</div> */}
                        {/* {
                            count > 0 && 
                            <div className={styles.continuous}>已连签{count}天，请继续坚持哦</div>
                        } */}
                        <div className={styles.title}>设置您的健康日历</div>
                        <div className={styles.head_tip}>
                            <span>请认真核对药品名称哦</span>
                            {/* <img src={icon_q} alt="" /> */}
                        </div>
                    </div>
                    <div className={styles.head_right}>
                        {/* <img src={calendar_icon} alt="" /> */}
                        {/* <img src={remind_calendar_bg} alt="" /> */}
                    </div>
                    <div className={styles.bottom_btns}>
                        <div className={`${styles.bnt1} ${ !showMedical ? styles.actived : ''}`} onClick={() => { setActiveItem({}); initMedication(); setIsMedicine(true); }} >
                            <img src={!showMedical ? btn_icon_medicine_purple : btn_icon_medicine_blue} alt="" />
                            <span>设置用药提醒</span>
                        </div>
                        <div className={`${styles.bnt2} ${ !showCure ? styles.actived : ''}`} onClick={() => { initCure(); setActiveItem({}); setIsCure(true); }} >
                            <img src={!showCure ? btn_icon_cure_purple : btn_icon_cure_blue } alt="" />
                            <span>设置就诊提醒</span>
                        </div>
                    </div>
                </div>
                {/* <div className={styles.sign_in_btn_wrap} style={{opacity: isTodaySigned === null ? '0' : '1'}}  >
                    <Button className={styles.sign_in_btn} onClick={() => { toSign() }} disabled={isTodaySigned} color="primary">{isTodaySigned ? '已签到' : '立即签到'}</Button>
                </div> */}
                <div className={styles.year}>
                    <div className={styles.yearName}>
                        <span onClick={() => { setVisible(true) }}>{currenrYear.toString()}</span>
                        <span onClick={() => { setVisible(true) }} className={styles.icon}></span>
                    </div>
                    {
                        visible && 
                        <Picker
                            defaultValue={currenrYear}
                            columns={yearColumns}
                            visible={visible}
                            onClose={() => { setVisible(false) }}
                            value={currenrYear}
                            onConfirm={v => { setCurrenrYear(v); changeYear(v) }}
                        />
                    }

                </div>

                <div className={styles.calendar}>
                    <div className={styles.monthList}>
                        {
                            monthList.map((v: any, i: number) => (
                                <div
                                    className={v.name === currentMonth ? `${styles.month} ${styles.currentMonth}` : styles.month}
                                    key={i}
                                    onClick={() => changeMonth(v.name)}
                                >
                                    <div className={styles.monthName}>
                                        {dateUtil.monthConversion(new Date(v.name).getMonth() + 1)}月
                                    </div>
                                    <div className={styles.record_num} hidden={v.count === 0}>{v.count}</div>
                                </div>
                            ))
                        }
                    </div>
                    <div className={styles.weekList}>
                        {
                            weekList.map((v: any, i: number) => (
                                <div className={styles.week} key={i}>{v.name}</div>
                            ))
                        }
                    </div>

                    <div className={styles.dayList}>
                        {
                            dayList.map((v: any, i: number) => (
                                <div
                                    className={v.date !== currentDay ? `${styles.day} ${styles.currentDay}` : styles.day}
                                    key={i}
                                    onClick={() => changDay(v.date)}
                                >
                                    {/* <div className={`${v.isSigned ? styles.signed_in : styles.signed_in_not} ${(isThisYearMonth && (thisDate <= v.name)) ? '' : styles.no_Num}`}>{v.name}</div> */}
                                    <div className={`${v.isActiveDay ? styles.signed_in : styles.signed_in_not} ${(isThisYearMonth && (thisDate <= v.name)) ? '' : styles.no_Num}`}>{v.name}</div>
                                    <div className={`${styles.current} ${v.count > 0 ? styles.record_num : styles.no_record_num}`}>
                                        {
                                            // v.isSigned ?
                                            (v.isCure || v.isMedicine) ?
                                            <div className={styles.icon_wrap} >
                                                {
                                                    v.isMedicine && 
                                                    <img className={styles.icon_medicine} src={icon_medicine} alt="" />
                                                }
                                                {
                                                    v.isCure && 
                                                    <img className={styles.icon_cure} src={icon_cure} alt="" />
                                                }
                                            </div>
                                            // <div className={`${styles.dot}`}></div>
                                            :
                                            null
                                        }
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
                {
                    showMedical && 
                    <div className={styles.medicine} >
                        <div>
                            <div className={styles.top}>
                                <div>用药提醒</div>
                                <img src={edit_blue}  onClick={() => { initMedication(); setActiveItem({}); setIsMedicine(true); }} alt="" />
                            </div>
                            <div className={styles.bottom}>您还未设置就诊提醒、请及时设置</div>
                        </div>
                        <div></div>
                    </div>
                }
                {
                    showCure && 
                    <div className={styles.cure}>
                        <div>
                            <div className={styles.top}>
                                <div>就诊提醒</div>
                                <img src={edit_blue} onClick={() => { initCure();  setActiveItem({}); setIsCure(true);}} alt="" />
                            </div>
                            <div className={styles.bottom}>您还未设置就诊提醒、请及时设置</div>
                        </div>
                        <div></div>
                    </div>
                }
                {
                    editedAllDateList && editedAllDateList.map((val: any, key: number) => {
                        // 就诊时间
                        if (val.type === 'medication') {
                            // 提醒时间距离今天
                            // let remindDayFromNow = ((new Date(val.startTime)).getTime() -  (new Date(nowDate)).getTime()) / (24 * 60 * 60 * 1000);
                            // // 治疗时间距离今天
                            // let cureDayFromNow = ((new Date(val.attendanceTime)).getTime() -  (new Date(nowDate)).getTime()) / (24 * 60 * 60 * 1000);
                            // 
                            // 提醒的间隔
                            const frequencyGapDay = frequencyToDayMap[val.frequency];
                            // 提醒的天数
                            const dayTimes = val.day ? val.day : 365 * 10; // 后者为长期提醒
                            // 总天数
                            const allDay = frequencyGapDay * dayTimes;
                            const futureFinishDay = new Date(new Date(val.startTime).getTime() + allDay * 24 * 60 * 60 * 1000);
                            // 提醒时间距离今天
                            let remindDayFromNow = ((new Date(val.startTime)).getTime() -  (new Date(nowDate)).getTime()) / (24 * 60 * 60 * 1000);
                            // 提醒结束时间时间距离今天 
                            let finishDayFromNow = ((new Date(futureFinishDay)).getTime() -  (new Date(nowDate)).getTime()) / (24 * 60 * 60 * 1000);
                            remindDayFromNow = Math.floor(remindDayFromNow);
                            finishDayFromNow = Math.floor(finishDayFromNow);
                            // finishDayFromNow
                            let _remindTimes = val.remindTimes ? val.remindTimes : [];
                            // 寻找最近一次未开始的，如果没有就是已经开始的那一次
                            let nowHours = new Date().getHours();
                            let nowMinute = new Date().getMinutes();
                            let plusCloseTime = '';
                            let minusCloseTime = '';
                            _remindTimes = _remindTimes.sort();
                            _remindTimes.some((val: any) => {
                                if (val.indexOf(':') >= 0) {
                                    let [ hour, minute ] = val.split(':');
                                    if (nowHours >= parseInt(hour) || (nowHours >= parseInt(hour) && nowMinute >= parseInt(minute))) {
                                        minusCloseTime = val;
                                    }
                                    if ((nowHours <= parseInt(hour) || ( nowHours <= parseInt(hour) && nowMinute <= parseInt(minute))) && !plusCloseTime) {
                                        plusCloseTime = val;
                                    }
                                    return minusCloseTime && plusCloseTime;
                                }
                            });
                            if (remindDayFromNow <= 0 && finishDayFromNow >= 0) {
                                // 用药
                                return (
                                    <div className={styles.medicine_cure_edit} key={key}>
                                        <div className={styles.top}>
                                            <div className={styles.tl}>
                                                <img className={styles.edit_medicine}  src={icon_medicine} alt="" />
                                                <span>
                                                    {val.otherDrugName || val.drugName}
                                                </span>
                                            </div>
                                            <Switch
                                                onChange={(vall: boolean) => changeSwitch(val, vall)} 
                                                defaultChecked={val.state == 1}
                                                className={styles.tr}
                                                style={{
                                                '--checked-color': '#7D56C2',
                                                '--height': '24px',
                                                '--width': '62px',
                                                '--adm-font-size-7': '10px',
                                                }}
                                                uncheckedText='已暂停' checkedText='已提醒'  />
                                            <img className={styles.edit_purple} src={edit_purple} onClick={() => { toActiveMedication(val) }} alt="" />
                                            <img className={styles.delete_purple} src={delete_purple} onClick={() => { toDelete(val) }} alt="" />
                                        </div>
                                        <div className={styles.bottom}>
                                            <div className={styles.b_content}>
                                                <div className={styles.bl}>
                                                    <div>
                                                        服用频次：
                                                    </div>
                                                    <div>
                                                        {takeMedicineTimesMap[val.frequency]}{_remindTimes.length + '次'}
                                                    </div>
                                                </div>
                                                <div className={styles.bm}>
                                                    <div>
                                                        服用天数:
                                                    </div>
                                                    <div>
                                                        {val.day ? val.day + '天' : '长期'}
                                                    </div>
                                                </div>
                                                <div className={styles.br}>
                                                    <img src={time_purple} alt="" />
                                                    <span>
                                                        {
                                                            plusCloseTime || minusCloseTime
                                                        }
                                                        {/* { 
                                                            val.remindTimes ? val.remindTimes.split(';')[0] : ''
                                                        } */}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className={styles.b_b}>
                                                <span>{val.startTime} 开始</span>
                                                <span>{_remindTimes.join('; ')}</span>
                                                {/* <span>2022-09-01开始</span> */}
                                            </div>
                                        </div>
                                    </div>
                                )
                            } else {
                                // 用药
                                return (
                                    <div className={`${styles.medicine_cure_edit} ${styles.medicine_cure}`} key={key}>
                                        <div className={styles.top}>
                                            <div className={styles.tl}>
                                                <img className={styles.edit_medicine} src={btn_icon_medicine_in_blue} alt="" />
                                                <span>
                                                    {val.otherDrugName || val.drugName}
                                                </span>
                                            </div>
                                            <Switch
                                                onChange={(vall: boolean) => changeSwitch(val, vall)} 
                                                defaultChecked={true}
                                                className={styles.tr}
                                                disabled={true}
                                                style={{
                                                '--checked-color': '#3C95F7',
                                                '--height': '24px',
                                                '--width': '62px',
                                                '--adm-font-size-7': '10px',
                                                }}
                                                checkedText={finishDayFromNow < 0 ? '已结束' : '未开始'} />
                                            <img className={styles.edit_purple} src={edit_blue} onClick={() => { toActiveMedication(val) }} alt="" />
                                            <img className={styles.delete_purple} src={delete_blue} onClick={() => { toDelete(val) }} alt="" />
                                        </div>
                                        <div className={styles.bottom}>
                                            <div className={styles.b_content}>
                                                <div className={styles.bl}>
                                                    <div>
                                                        服用频次：
                                                    </div>
                                                    <div className={styles.frequency}>
                                                        {takeMedicineTimesMap[val.frequency]}{ _remindTimes.length + '次'}
                                                    </div>
                                                </div>
                                                <div className={styles.bm}>
                                                    <div>
                                                        服用天数:
                                                    </div>
                                                    <div className={styles.day}>
                                                        {val.day ? val.day + '天' : '长期'}
                                                    </div>
                                                </div>
                                                <div className={styles.br}>
                                                    {/* <img src={time_purple} alt="" /> */}
                                                    <span>
                                                        {
                                                            finishDayFromNow < 0 ?
                                                            '已结束'
                                                            : 
                                                            '未开始'
                                                        }
                                                        
                                                        {/* { 
                                                            val.remindTimes ? val.remindTimes.split(';')[0] : ''
                                                        } */}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className={styles.b_b}>
                                                <span>{val.startTime}开始</span>
                                                <span>{_remindTimes.join('; ')}</span>
                                                {/* <span>{val.startTime}开始</span>
                                                <span>{val.remindTimes}</span> */}
                                                {/* <span>2022-09-01开始</span> */}
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        } else if (val.type === 'attendance') {
                            // 提醒时间距离今天
                            let remindDayFromNow = ((new Date(val.startTime)).getTime() -  (new Date(nowDate)).getTime()) / (24 * 60 * 60 * 1000);
                            // 治疗时间距离今天 （结束时间）
                            let cureDayFromNow = ((new Date(val.attendanceTime)).getTime() -  (new Date(nowDate)).getTime()) / (24 * 60 * 60 * 1000);
                            remindDayFromNow = Math.floor(remindDayFromNow);
                            cureDayFromNow = Math.floor(cureDayFromNow);
                            if (remindDayFromNow <= 0 && cureDayFromNow >= 0) {
                                // 提醒
                                return (
                                <div className={styles.medicine_cure_edit} key={key}>
                                    <div className={styles.top}>
                                        <div className={styles.tl}>
                                            <img className={styles.edit_medicine}  src={icon_cure} alt="" />
                                            <span>
                                                就诊提醒
                                            </span>
                                        </div>
                                        <Switch
                                            onChange={(vall: boolean) => changeSwitch(val, vall)}
                                            defaultChecked={val.state == 1}
                                            className={styles.tr}
                                            style={{
                                            '--checked-color': '#7D56C2',
                                            '--height': '24px',
                                            '--width': '62px',
                                            '--adm-font-size-7': '10px',
                                            }}
                                            uncheckedText='已暂停' checkedText='已提醒'  />
                                        <img className={styles.edit_purple} src={edit_purple} onClick={() => { setIsCure(true); setActiveItem(val);
                                            setHospitalName(val.hospitalName); setDepartmentName(val.departmentName); setDepartmentName(val.deptName); setVisitTime(val.attendanceTime); setVisitRemindTime(val.startTime); }}  alt="" />
                                        <img className={styles.delete_purple} src={delete_purple} onClick={() => { toDelete(val) }}  alt="" />
                                    </div>
                                    <div className={styles.bottom}>
                                        <div className={styles.cure_content}>
                                            <div className={styles.line_item_wrap}>
                                                <div className={styles.line_item}>
                                                    <span>医院:</span>
                                                    <span>{val.hospitalName}</span>
                                                </div>
                                                <div className={styles.line_item}>
                                                    <span>科室:</span>
                                                    <span>{val.deptName}</span>
                                                </div>
                                                <div className={styles.line_item}>
                                                    <span>日期:</span>
                                                    <span>{val.attendanceTime}</span>
                                                </div>
                                            </div>
                                            <div className={styles.br}>
                                                    <img src={time_purple} alt="" />
                                                    {
                                                        cureDayFromNow == 0 ?
                                                        <span>今天</span>
                                                        :
                                                        <span>{cureDayFromNow}天后</span>
                                                    }
                                                    
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                );
                            } else {
                                // 过期
                                return (
                                    <div className={`${styles.medicine_cure_edit} ${styles.medicine_cure}`} key={key}>
                                        <div className={styles.top}>
                                            <div className={styles.tl}>
                                                <img className={styles.edit_medicine} src={cure_blue} alt="" />
                                                <span className={styles.remind}>
                                                    就诊提醒
                                                </span>
                                            </div>
                                            <Switch
                                                checked={true}
                                                disabled={true}
                                                className={styles.tr}
                                                style={{
                                                '--checked-color': '#3C95F7',
                                                '--height': '24px',
                                                '--width': '62px',
                                                '--adm-font-size-7': '10px',
                                                }}
                                                checkedText={cureDayFromNow < 0 ? '已结束' : '未开始'}  />
                                            <img className={styles.edit_purple} src={edit_blue} onClick={() => { setIsCure(true); setActiveItem(val); 
                                                setHospitalName(val.hospitalName); setDepartmentName(val.deptName); setVisitTime(val.attendanceTime); setVisitRemindTime(val.startTime); }}  alt="" />
                                            <img className={styles.delete_purple} src={delete_blue} onClick={() => { toDelete(val) }}  alt="" />
                                        </div>
                                        <div className={styles.bottom}>
                                            <div className={styles.cure_content}>
                                                <div className={styles.line_item_wrap}>
                                                    <div className={styles.line_item}>
                                                        <span>医院:</span>
                                                        <span>{val.hospitalName}</span>
                                                    </div>
                                                    <div className={styles.line_item}>
                                                        <span>科室:</span>
                                                        <span>{val.deptName}</span>
                                                    </div>
                                                    <div className={styles.line_item}>
                                                        <span>日期:</span>
                                                        <span>{val.attendanceTime}</span>
                                                    </div>
                                                </div>
                                                <div className={styles.br}>
                                                    {/* if (remindDayFromNow <= 0 && cureDayFromNow >= 0) { */}
                                                    {
                                                        cureDayFromNow < 0 ? 
                                                        <span>已结束</span>
                                                        : 
                                                        <span>未开始</span>
                                                    }
                                                    {/* <span>已完成</span> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        }
                    })
                }
                <div className={styles.b_gap}></div>
                {/* <div className={styles.medicine_cure_edit}>
                    <div className={styles.top}>
                        <div className={styles.tl}>
                            <img className={styles.edit_medicine}  src={icon_medicine} alt="" />
                            <span>
                                洛拉替尼
                            </span>
                        </div>
                        <Switch
                            className={styles.tr}
                            style={{
                            '--checked-color': '#7D56C2',
                            '--height': '24px',
                            '--width': '62px',
                            '--adm-font-size-7': '10px',
                            }}
                            uncheckedText='已暂停' checkedText='已提醒'  />
                        <img className={styles.edit_purple} src={edit_purple} alt="" />
                        <img className={styles.delete_purple} src={delete_purple} alt="" />
                    </div>
                    <div className={styles.bottom}>
                        <div className={styles.b_content}>
                            <div className={styles.bl}>
                                <div>
                                    服用频次：
                                </div>
                                <div>
                                    每日1次
                                </div>
                            </div>
                            <div className={styles.bm}>
                                <div>
                                    服用天数:
                                </div>
                                <div>
                                    30天
                                </div>
                            </div>
                            <div className={styles.br}>
                                <img src={time_purple} alt="" />
                                <span>12:00</span>
                            </div>
                        </div>
                        <div className={styles.b_b}>
                            <span>2022-09-01开始</span>
                            <span>2022-09-01开始</span>
                        </div>
                    </div>
                </div> */}
                {/* <div className={styles.medicine_cure_edit}>
                    <div className={styles.top}>
                        <div className={styles.tl}>
                            <img className={styles.edit_medicine}  src={icon_cure} alt="" />
                            <span>
                                就诊提醒
                            </span>
                        </div>
                        <Switch
                            className={styles.tr}
                            style={{
                            '--checked-color': '#7D56C2',
                            '--height': '24px',
                            '--width': '62px',
                            '--adm-font-size-7': '10px',
                            }}
                            uncheckedText='已暂停' checkedText='已提醒'  />
                        <img className={styles.edit_purple} src={edit_purple} alt="" />
                        <img className={styles.delete_purple} src={delete_purple} alt="" />
                    </div>
                    <div className={styles.bottom}>
                        <div className={styles.cure_content}>
                            <div className={styles.line_item_wrap}>
                                <div className={styles.line_item}>
                                    <span>医院:</span>
                                    <span>复旦大学附属中山医院</span>
                                </div>
                                <div className={styles.line_item}>
                                    <span>科室:</span>
                                    <span>肿瘤内科</span>
                                </div>
                                <div className={styles.line_item}>
                                    <span>日期:</span>
                                    <span>2022-09-15</span>
                                </div>
                            </div>
                            <div className={styles.br}>
                                    <img src={time_purple} alt="" />
                                    <span>6天后</span>
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* <div className={`${styles.medicine_cure_edit} ${styles.medicine_cure}`}>
                    <div className={styles.top}>
                        <div className={styles.tl}>
                            <img className={styles.edit_medicine}  src={cure_blue} alt="" />
                            <span className={styles.remind}>
                                就诊提醒
                            </span>
                        </div>
                        <Switch
                            className={styles.tr}
                            style={{
                            '--checked-color': '#3C95F7',
                            '--height': '24px',
                            '--width': '62px',
                            '--adm-font-size-7': '10px',
                            }}
                            uncheckedText='未完成' checkedText='已完成'  />
                        <img className={styles.edit_purple} src={edit_blue} alt="" />
                        <img className={styles.delete_purple} src={delete_blue} alt="" />
                    </div>
                    <div className={styles.bottom}>
                        <div className={styles.cure_content}>
                            <div className={styles.line_item_wrap}>
                                <div className={styles.line_item}>
                                    <span>医院:</span>
                                    <span>复旦大学附属中山医院</span>
                                </div>
                                <div className={styles.line_item}>
                                    <span>科室:</span>
                                    <span>肿瘤内科</span>
                                </div>
                                <div className={styles.line_item}>
                                    <span>日期:</span>
                                    <span>2022-09-15</span>
                                </div>
                            </div>
                            <div className={styles.br}>
                                <span>已完成</span>
                            </div>
                        </div>
                    </div>
                </div> */}
                {
                    isMedicine &&
                    <div className={styles.dialog_medicine}>
                    <div className={styles.dialog_medicine_content}>
                        <img className={styles.remind_bell} src={remind_bell} alt="" />
                        <div className={styles.dialog_title}>设置用药提醒</div>
                        <div className={styles.dialog_item_name}>治疗方式</div>
                        <div className={`${styles.dialog_input} ${styles.dialog_select}`} onClick={treatmentEdit}>
                            {
                                treatment ? 
                                <div className={styles.inputed}>{treatment}</div>
                                :
                                <div className={styles.placeholder}>请选择治疗方式</div>
                            }
                        </div>
                        <div className={styles.dialog_item_name}>{treatment != '其他' ? '选择用药' : '药品名称'}</div>
                        {
                            medicine !== '其他' &&
                            <div className={`${styles.dialog_input} ${treatment != '其他' ? styles.dialog_select : ''}`}>
                                {
                                    treatment != '其他' ?
                                    <div  onClick={selectMedicineEdit} className={`${medicine ? styles.inputed : styles.placeholder}`}>{medicine ? medicine : '请选择用药'}</div>
                                    :
                                    <Input placeholder='请输入用药名称' value={otherMedicine} onChange={medicineNameChanged} ></Input>
                                }
                            </div>
                        }
                        {
                            medicine == '其他' &&
                            <>
                                <div className={`${styles.dialog_input} ${styles.dialog_select}`}>
                                    <div onClick={selectMedicineEdit} className={`${medicine ? styles.inputed : styles.placeholder}`}>{medicine}</div>
                                </div>
                                <div className={styles.dialog_item_name}>{'药品名称'}</div>
                                <div className={styles.dialog_input}>
                                    <Input placeholder='请输入用药名称' value={otherMedicine} onChange={medicineNameChanged}  ></Input>
                                </div>
                            </>
                        }
                        {/* <div className={styles.dialog_item_name}>提醒方式</div>
                        <div className={styles.dialog_input}>
                            <div className={styles.placeholder}>请选择提醒方式</div>
                        </div> */}
                        <div className={styles.dialog_item_name}>使用方式</div>
                        <div className={`${styles.dialog_input} ${styles.dialog_select}`} onClick={showUseWay}>
                            <div className={`${useWay ? styles.inputed : styles.placeholder}`}>{useWay ? useWay : '请选择使用方式'}</div>
                        </div>
                        <div className={styles.dialog_item_name}>开始时间</div>
                        <div className={`${styles.dialog_input} ${styles.dialog_select}`} onClick={showStartTime}>
                            <div className={`${startTime ? styles.inputed : styles.placeholder}`}>{startTime ? startTime : '请选择开始时间'}</div>
                        </div>
                        <div className={styles.dialog_item_name}>服用天数</div>
                        <div className={styles.dialog_input}>
                            {/* <div className={styles.placeholder}>请选择服用天数</div> */}
                            <Input placeholder={useWay === '持续用药' ? '长期' : '请输入服用天数'} disabled={useWay === '持续用药'} value={takedDay} onChange={takedDayChanged} type='number' ></Input>
                        </div>
                        <div className={styles.dialog_item_name}>服用频次</div>
                        <div className={`${styles.dialog_input} ${styles.dialog_select}`}>
                            <div className={`${takedFrequencyTimes !== '' ? styles.inputed : styles.placeholder}`} 
                                onClick={medicineTakedTimes}
                            >
                                {
                                    takedFrequencyTimes ? takedFrequencyTimesLabel : '请选择服用频次'
                                }
                            </div>
                        </div>

                        {/* <div className={styles.dialog_item_name}>服用频次</div>
                        <div className={styles.dialog_input}>
                            <div className={styles.placeholder} 
                                onClick={medicineTaked}
                            >请选择服用频次</div>
                        </div> */}
                        <div className={styles.dialog_item_name}>提醒时间</div>
                        <div className={styles.dialog_remind_time}>
                            {
                                remindTimeList.map((val: any, index: number) => (
                                    <div key={index} className={styles.remind_time_floor}>
                                        {
                                            val.map((v: any, i: number) => (
                                                <div className={styles.remind_time_item} key={i}>
                                                    <div className={styles.remind_time_content}>
                                                        <div className={styles.remind_time_icon}>
                                                            <img onClick={() => { remindItemActive(index, i, v)}} className={`${(v.inputed || v.type == 'plus') ? '' : styles.opacity05}`} src={v.type == 'plus' ? icon_time_plus_blue : icon_time_blue} alt="" />
                                                            {
                                                                v.inputed && 
                                                                <img className={styles.delete} src={icon_delete}  onClick={() => { remindItemDelete(index, i, v)}} alt="" />
                                                            }
                                                        </div>
                                                        {
                                                            i !== (val.length - 1) && 
                                                            <div className={styles.remind_time_line} >
                                                            </div>
                                                        }
                                                    </div>
                                                    <div onClick={() => { remindItemActive(index, i, v)}} className={`${styles.remind_time_tip} ${v.inputed ? styles.time_inputed : v.type == 'plus' ? styles.time_plus : styles.opacity05}`}>
                                                        {v.inputed ? v.minute + ':' + v.second : v.type == 'plus' ? '添加时间' : '请输入时间'}
                                                        {
                                                           v.inputed &&  
                                                           <div className={styles.triangle}></div>
                                                        }
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                ))
                            }
                        </div>
                        <div className={styles.dialog_btns}>
                            <div>
                                <Button color='primary' fill='outline'  onClick={() => { setIsMedicine(false); }} >取消</Button>
                            </div>
                            <div>
                                <Button color='primary' fill='solid' onClick={medicineSave} >保存</Button>
                            </div>
                        </div>
                    </div>
                    </div>
                }
                {
                    isCure &&
                    <div className={styles.dialog_cure}>
                        <img className={styles.remind_bell} src={remind_bell} alt="" />
                        <div className={styles.dialog_title}>设置就诊提醒</div>
                        <div className={styles.dialog_item_name}>医院名称</div>
                        <div className={`${styles.dialog_input}`}>
                            <Input placeholder='请输入要前往的医院名称' value={hospitalName} onChange={hospitalChange} ></Input>
                        </div>
                        <div className={styles.dialog_item_name}>科室名称</div>
                        <div className={`${styles.dialog_input}`}>
                            <Input placeholder='请输入科室名称' value={departmentName}  onChange={departChange} ></Input>
                        </div>
                        <div className={styles.dialog_item_name}>就诊日期</div>
                        <div className={`${styles.dialog_input} ${styles.dialog_select}`} onClick={() => { cureTime() }}>
                            <div className={`${visitTime ? styles.inputed : styles.placeholder}`} onClick={() => { cureTime() }}>{visitTime ? visitTime : '请选择就诊日期'}</div>
                        </div>
                        <div className={styles.dialog_item_name}>提醒开始日期</div>
                        <div className={`${styles.dialog_input} ${styles.dialog_select}`}>
                            <div className={`${visitRemindTime ? styles.inputed : styles.placeholder}`}  onClick={() => { cureRemindTime() }}>{visitRemindTime ? visitRemindTime : '请选择提醒开始日期'}</div>
                        </div>
                        <div className={styles.dialog_btns}>
                            <div>
                                <Button color='primary' fill='outline'  onClick={() => { setIsCure(false); }} >取消</Button>
                            </div>
                            <div>
                                <Button color='primary' fill='solid' onClick={cureSave} >保存</Button>
                            </div>
                        </div>
                    </div>
                }
                {
                   (isCure || isMedicine) &&
                   <div className={styles.mask} onClick={() => { setIsCure(false); setIsMedicine(false); }} >
                   </div>
                }
                {
                    timeVisible && 
                    <DatePicker
                        title='时间选择'
                        precision='day'
                        visible={timeVisible}
                        onClose={() => {
                            setTimeVisible(false)
                        }}
                        defaultValue={pickerDefaultDate ? new Date(pickerDefaultDate) : now}
                        max={maxNow}
                        onConfirm={val => {
                            if (val) {
                                let _year: any = val.getFullYear();
                                let _month: any = val.getMonth() + 1;
                                let _date: any = val.getDate();
                                _month = _month < 10 ? ('0' + _month) : _month;
                                _date = _date < 10 ? ('0' + _date) : _date;
                                const _selectDate = _year + '-' + _month + '-' + _date;
                                if (timeType == 'start') {
                                    setStartTime(_selectDate);
                                } else if (timeType == 'visit') {
                                    setVisitTime(_selectDate);
                                } else if (timeType == 'visitRemind') {
                                    setVisitRemindTime(_selectDate);
                                }
                            }
                        }}
                        renderLabel={labelRenderer}
                    />
                }
        </div>
    )
}

export default Calendar